// Errores propios de la apertura de cuenta → qué lee el vendedor.
import { ApiError } from '@/api/errors';

export const ACCOUNT_OPENING_ERROR_MESSAGES = {
    FUNDS_NOT_OWN:
        'La cuenta solo se puede abrir si el dinero que va a manejar es del propio cliente.',
    ACCOUNT_OPENING_PROFILE_INCOMPLETE:
        'Faltan respuestas del perfil del cliente. Contéstalas todas para abrir su cuenta.',
    ACCOUNT_OPENING_NO_SALE: 'Esta es una apertura de cuenta: no admite acciones de venta.',
    ACCOUNT_NOT_READY:
        'La cuenta del cliente todavía no está lista; intenta de nuevo en unos minutos.',
    ACCOUNT_OPENING_WITH_PROSPECT:
        'Una apertura de cuenta no puede reanudar un prospecto. Empieza desde «Abrir cuenta».',
} as const;

export type AccountOpeningErrorCode = keyof typeof ACCOUNT_OPENING_ERROR_MESSAGES;

export interface AccountOpeningFailure {
    code: AccountOpeningErrorCode;
    message: string;
    /** Solo con ACCOUNT_OPENING_PROFILE_INCOMPLETE: los MXN_* que no llegaron. */
    missingFields: string[];
}

function isAccountOpeningCode(code: string): code is AccountOpeningErrorCode {
    return Object.hasOwn(ACCOUNT_OPENING_ERROR_MESSAGES, code);
}

function missingFieldsOf(data: unknown): string[] {
    if (typeof data !== 'object' || data === null) return [];
    const fields = (data as { missingFields?: unknown }).missingFields;
    return Array.isArray(fields) ? fields.filter((f): f is string => typeof f === 'string') : [];
}

/** El error tipado de la apertura con su mensaje; `null` si es otro error. */
export function accountOpeningFailureOf(error: unknown): AccountOpeningFailure | null {
    if (!(error instanceof ApiError) || !isAccountOpeningCode(error.code)) return null;
    return {
        code: error.code,
        message: ACCOUNT_OPENING_ERROR_MESSAGES[error.code],
        missingFields:
            error.code === 'ACCOUNT_OPENING_PROFILE_INCOMPLETE' ? missingFieldsOf(error.data) : [],
    };
}
